import { IconButton } from '@mui/material'
import { MdAccessTime, MdCheckCircle } from 'react-icons/md'
import AgendaButton from './AgendaButton'

const IconeEspecialista = ({
  icon: Icon,
  titulo,
  status,
  onClick,
  agendas = [],
}) => {
  const renderStatus = () => {
    if (status === 1) {
      return (
        <MdAccessTime
          style={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            fontSize: 12,
            color: '#1976d2',
          }}
        />
      )
    }

    if (status === 2) {
      return (
        <MdCheckCircle
          style={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            fontSize: 12,
            color: 'green',
          }}
        />
      )
    }

    return null
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        {agendas.length === 0 ? (
          <IconButton onClick={onClick}>
            <Icon
              size={25}
              color={
                status === 0 ? '#9e9e9e' : status === 1 ? '#1976d2' : '#2e7d32'
              }
            />
          </IconButton>
        ) : (
          <AgendaButton
            Icon={
              <Icon
                size={25}
                color={
                  status === 0
                    ? '#9e9e9e'
                    : status === 1
                      ? '#1976d2'
                      : '#2e7d32'
                }
              />
            }
            status={status}
            agendas={agendas}
          />
        )}

        {renderStatus()}
      </div>
      <div style={{ fontSize: 8 }}>{titulo}</div>
    </div>
  )
}

export default IconeEspecialista
